import { updater } from "../../utils/updater.js";

/**
 * Recaptcha API factory.
 *
 */
export function recaptchaFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const setShowRecaptcha = (captchaName, callback) => {
    updateState((draft) => void (draft.showRecaptcha[captchaName] = callback));
  };
  const getShowRecaptcha = () => state.showRecaptcha;

  const getRecaptchaData = () => state;
  const getRecaptchaSize = () => state.getRecaptchaSize;

  return {
    setShowRecaptcha,
    getShowRecaptcha,
    getRecaptchaSize,
    getRecaptchaData,
  };
}

export default recaptchaFactory;
